import Component from './post_name.vue'
export default Component
